import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getContent, getErrorMessage } from '../../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import API_SETTINGS from '../../../api/apiSettings';
import Dropdown from '../../../components/Common/Dropdown';
import ActionType from '../../../redux/reducer/globalActionType';
import Alert from '../../../components/Alert/Alert';
import moment from 'moment';
import { CheckPermissionApi, CheckPermissionComponent } from '../../../util/permission';
import { SETTING_PARAMETER_UPDATE, SETTING_PARAMETER_VIEW } from '../../../constants/menuPermissionConstant';

class Parameter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            priority: {
                page: 1,
                limit: 100,
                data: [],
                value: 0,
                updatedAt: '',
                updatedBy: '',
            },
            priorityDetail: {},
            targetResolutionTime: 0,
            targetResolutionTimeDisabled: true,
            channel: {
                page: 1,
                limit: 100,
                data: [],
                value: 0,
                updatedAt: '',
                updatedBy: '',
            },
            channelDetail: {},
            targetResponseTime: 0,
            targetResponseTimeDisabled: true,
            ticketWaiting: {
                page: 1,
                limit: 10,
                data: [],
                value: 0,
                updatedAt: '',
                updatedBy: ''
            },
            ticketWaitingDetail: {},
            ticketWaitingTime: 0,
            tolerance: {
                page: 1,
                limit: 10,
                data: [],
                value: 0,
                updatedAt: '',
                updatedBy: ''
            },
            toleranceDetail: {},
            toleranceTime: 0,
            forgeLogout: {
                page: 1,
                limit: 10,
                data: [],
                value: 0,
                updatedAt: '',
                updatedBy: ''
            },
            forgeLogoutDetail: {},
            forgeLogoutTime: 0,
            maxReassignPhoneEmail: {
                page: 1,
                limit: 10,
                data: [],
                value: 0,
                updatedAt: '',
                updatedBy: ''
            },
            maxReassignPhoneEmailDetail: {},
            maxReassignPhoneEmailTime: 0,
            maxReassignLiveChat: {
                page: 1,
                limit: 10,
                data: [],
                value: 0,
                updatedAt: '',
                updatedBy: ''
            },
            maxReassignLiveChatDetail: {},
            maxReassignLiveChatTime: 0,
            maxQueueReassign: {
                page: 1,
                limit: 10,
                data: [],
                value: 0,
                updatedAt: '',
                updatedBy: ''
            },
            maxQueueReassignDetail: {},
            maxQueueReassignTime: 0,
            workstart: {
                page: 1,
                limit: 10,
                data: [],
                value: 0,
                updatedAt: '',
                updatedBy: ''
            },
            workstartDetail: {},
            workstartTime: '',
            workend: {
                page: 1,
                limit: 10,
                data: [],
                value: 0,
                updatedAt: '',
                updatedBy: ''
            },
            workendDetail: {},
            workendTime: '',
            breaktime: {
                page: 1,
                limit: 10,
                data: [],
                value: 0,
                updatedAt: '',
                updatedBy: ''
            },
            breaktimeDetail: {},
            breaktimeTime: 0,
            cutOffCommission: {
                page: 1,
                limit: 10,
                data: [],
                value: 0,
                updatedAt: '',
                updatedBy: ''
            },
            cutOffCommissionDetail: {},
            cutOffCommissionTime: 0,
            maxUserOffline: {
                page: 1,
                limit: 10,
                data: [],
                value: 0,
                updatedAt: '',
                updatedBy: ''
            },
            maxUserOfflineDetail: {},
            maxUserOfflineDay: 0,
            intervalGrabTicket: {
                page: 1,
                limit: 10,
                data: [],
                value: 0,
                updatedAt: '',
                updatedBy: ''
            },
            intervalGrabTicketDetail: {},
            intervalGrabTicketTime: 0,
            intervalGrabTicketTimeout: {
                page: 1,
                limit: 10,
                data: [],
                value: 0,
                updatedAt: '',
                updatedBy: ''
            },
            intervalGrabTicketTimeoutDetail: {},
            intervalGrabTicketTimeoutTime: 0,
            showConfirmAlert: false,
            showSuccessAlert: false,
            showErrorAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    getListParameterPriority = () => {
        API_SETTINGS.getListParameterPriority(this.state.priority.page, this.state.priority.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        priority: {
                            ...this.state.priority,
                            data: getContent(res)
                        }
                    })
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListParameterChannel = () => {
        API_SETTINGS.getListParameterChannel(this.state.channel.page, this.state.channel.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        channel: {
                            ...this.state.channel,
                            data: getContent(res)
                        }
                    })
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListParameterTicketWaiting = () => {
        API_SETTINGS.getListParameterTicketWaiting(this.state.ticketWaiting.page, this.state.ticketWaiting.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        ticketWaiting: {
                            ...this.state.ticketWaiting,
                            data: getContent(res),
                            updatedAt: getContent(res)[0].updated_at,
                            updatedBy: getContent(res)[0].modified_by
                        }
                    })
                    this.getListParameterTicketWaitingDetail(getContent(res)[0].id)
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListParameterTolerance = () => {
        API_SETTINGS.getListParameterTolerance(this.state.tolerance.page, this.state.tolerance.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        tolerance: {
                            ...this.state.tolerance,
                            data: getContent(res),
                            updatedAt: getContent(res)[0].updated_at,
                            updatedBy: getContent(res)[0].modified_by
                        }
                    })
                    this.getListParameterToleranceDetail(getContent(res)[0].id)
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListParameterForgeLogout = () => {
        API_SETTINGS.getListParameterForgeLogout(this.state.forgeLogout.page, this.state.forgeLogout.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        forgeLogout: {
                            ...this.state.forgeLogout,
                            data: getContent(res),
                            updatedAt: getContent(res)[0].updated_at,
                            updatedBy: getContent(res)[0].modified_by
                        }
                    })
                    this.getListParameterForgeLogoutDetail(getContent(res)[0].id)
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListParameterMaxReassignPhoneEmail = () => {
        API_SETTINGS.getListParameterMaxReassignPhoneEmail(this.state.maxReassignPhoneEmail.page, this.state.maxReassignPhoneEmail.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        maxReassignPhoneEmail: {
                            ...this.state.maxReassignPhoneEmail,
                            data: getContent(res),
                            updatedAt: getContent(res)[0].updated_at,
                            updatedBy: getContent(res)[0].modified_by
                        }
                    })
                    this.getListParameterMaxReassignPhoneEmailDetail(getContent(res)[0].id)
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListParameterMaxReassignLiveChat = () => {
        API_SETTINGS.getListParameterMaxReassignLiveChat(this.state.maxReassignLiveChat.page, this.state.maxReassignLiveChat.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        maxReassignLiveChat: {
                            ...this.state.maxReassignLiveChat,
                            data: getContent(res),
                            updatedAt: getContent(res)[0].updated_at,
                            updatedBy: getContent(res)[0].modified_by
                        }
                    })
                    this.getListParameterMaxReassignLiveChatDetail(getContent(res)[0].id)
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListParameterMaxQueueReassign = () => {
        API_SETTINGS.getListParameterMaxQueueReassign(this.state.maxQueueReassign.page, this.state.maxQueueReassign.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        maxQueueReassign: {
                            ...this.state.maxQueueReassign,
                            data: getContent(res),
                            updatedAt: getContent(res)[0].updated_at,
                            updatedBy: getContent(res)[0].modified_by
                        }
                    })
                    this.getListParameterMaxQueueReassignDetail(getContent(res)[0].id)
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListParameterWorkstart = () => {
        API_SETTINGS.getListParameterWorkstart(this.state.workstart.page, this.state.workstart.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        workstart: {
                            ...this.state.workstart,
                            data: getContent(res),
                            updatedAt: getContent(res)[0].updated_at,
                            updatedBy: getContent(res)[0].modified_by
                        }
                    })
                    this.getListParameterWorkstartDetail(getContent(res)[0].id)
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListParameterWorkend = () => {
        API_SETTINGS.getListParameterWorkend(this.state.workend.page, this.state.workend.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        workend: {
                            ...this.state.workend,
                            data: getContent(res),
                            updatedAt: getContent(res)[0].updated_at,
                            updatedBy: getContent(res)[0].modified_by
                        }
                    })
                    this.getListParameterWorkendDetail(getContent(res)[0].id)
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListParameterBreaktime = () => {
        API_SETTINGS.getListParameterBreaktime(this.state.breaktime.page, this.state.breaktime.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        breaktime: {
                            ...this.state.breaktime,
                            data: getContent(res),
                            updatedAt: getContent(res)[0].updated_at,
                            updatedBy: getContent(res)[0].modified_by
                        }
                    })
                    this.getListParameterBreaktimeDetail(getContent(res)[0].id)
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListParameterCutOffCommission = () => {
        API_SETTINGS.getListParameterCutOffCommission(this.state.cutOffCommission.page, this.state.cutOffCommission.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        cutOffCommission: {
                            ...this.state.cutOffCommission,
                            data: getContent(res),
                            updatedAt: getContent(res)[0].updated_at,
                            updatedBy: getContent(res)[0].modified_by
                        }
                    })
                    this.getListParameterCutOffCommissionDetail(getContent(res)[0].id)
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListParameterMaxUserOffline = () => {
        API_SETTINGS.getListParameterMaxUserOffline(this.state.maxUserOffline.page, this.state.maxUserOffline.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        maxUserOffline: {
                            ...this.state.maxUserOffline,
                            data: getContent(res),
                            updatedAt: getContent(res)[0].updated_at,
                            updatedBy: getContent(res)[0].modified_by
                        }
                    })
                    this.getListParameterMaxUserOfflineDetail(getContent(res)[0].id)
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListParameterIntervalGrabTicket = () => {
        API_SETTINGS.getListParameterIntervalGrabTicket(this.state.intervalGrabTicket.page, this.state.intervalGrabTicket.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        intervalGrabTicket: {
                            ...this.state.intervalGrabTicket,
                            data: getContent(res),
                            updatedAt: getContent(res)[0].updated_at,
                            updatedBy: getContent(res)[0].modified_by
                        }
                    })
                    this.getListParameterIntervalGrabTicketDetail(getContent(res)[0].id)
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListParameterIntervalGrabTicketTimeout = () => {
        API_SETTINGS.getListParameterIntervalGrabTicketTimeout(this.state.intervalGrabTicketTimeout.page, this.state.intervalGrabTicketTimeout.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        intervalGrabTicketTimeout: {
                            ...this.state.intervalGrabTicketTimeout,
                            data: getContent(res),
                            updatedAt: getContent(res)[0].updated_at,
                            updatedBy: getContent(res)[0].modified_by
                        }
                    })
                    this.getListParameterIntervalGrabTicketTimeoutDetail(getContent(res)[0].id)
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    handleChangePriority = data => {
        API_SETTINGS.getListParameterDetail(data.value, this.props.token)
            .then(res => {
                this.setState({
                    priorityDetail: getContent(res),
                    targetResolutionTimeDisabled: false,
                    priority: {
                        ...this.state.priority,
                        updatedAt: data.updatedAt,
                        updatedBy: data.updatedBy
                    }
                })
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    handleChangeChannel = data => {
        API_SETTINGS.getListParameterDetail(data.value, this.props.token)
            .then(res => {
                this.setState({
                    channelDetail: getContent(res),
                    targetResponseTimeDisabled: false,
                    channel: {
                        ...this.state.channel,
                        updatedAt: data.updatedAt,
                        updatedBy: data.updatedBy
                    }
                })
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListParameterTicketWaitingDetail = id => {
        API_SETTINGS.getListParameterDetail(id, this.props.token)
            .then(res => {
                this.setState({
                    ticketWaitingDetail: getContent(res)
                })
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListParameterToleranceDetail = id => {
        API_SETTINGS.getListParameterDetail(id, this.props.token)
            .then(res => {
                this.setState({
                    toleranceDetail: getContent(res)
                })
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListParameterForgeLogoutDetail = id => {
        API_SETTINGS.getListParameterDetail(id, this.props.token)
            .then(res => {
                this.setState({
                    forgeLogoutDetail: getContent(res)
                })
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListParameterMaxReassignPhoneEmailDetail = id => {
        API_SETTINGS.getListParameterDetail(id, this.props.token)
            .then(res => {
                this.setState({
                    maxReassignPhoneEmailDetail: getContent(res)
                })
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListParameterMaxReassignLiveChatDetail = id => {
        API_SETTINGS.getListParameterDetail(id, this.props.token)
            .then(res => {
                this.setState({
                    maxReassignLiveChatDetail: getContent(res)
                })
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListParameterMaxQueueReassignDetail = id => {
        API_SETTINGS.getListParameterDetail(id, this.props.token)
            .then(res => {
                this.setState({
                    maxQueueReassignDetail: getContent(res)
                })
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListParameterWorkstartDetail = id => {
        API_SETTINGS.getListParameterDetail(id, this.props.token)
            .then(res => {
                this.setState({
                    workstartDetail: getContent(res)
                })
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListParameterWorkendDetail = id => {
        API_SETTINGS.getListParameterDetail(id, this.props.token)
            .then(res => {
                this.setState({
                    workendDetail: getContent(res)
                })
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListParameterBreaktimeDetail = id => {
        API_SETTINGS.getListParameterDetail(id, this.props.token)
            .then(res => {
                this.setState({
                    breaktimeDetail: getContent(res)
                })
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListParameterCutOffCommissionDetail = id => {
        API_SETTINGS.getListParameterDetail(id, this.props.token)
            .then(res => {
                this.setState({
                    cutOffCommissionDetail: getContent(res)
                })
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListParameterMaxUserOfflineDetail = id => {
        API_SETTINGS.getListParameterDetail(id, this.props.token)
            .then(res => {
                this.setState({
                    maxUserOfflineDetail: getContent(res)
                })
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListParameterIntervalGrabTicketDetail = id => {
        API_SETTINGS.getListParameterDetail(id, this.props.token)
            .then(res => {
                this.setState({
                    intervalGrabTicketDetail: getContent(res)
                })
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListParameterIntervalGrabTicketTimeoutDetail = id => {
        API_SETTINGS.getListParameterDetail(id, this.props.token)
            .then(res => {
                this.setState({
                    intervalGrabTicketTimeoutDetail: getContent(res)
                })
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleSubmit = e => {
        e.preventDefault();
        this.setState({ showConfirmAlert: true })
    }

    handleUpdateParameter = async () => {
        if (CheckPermissionApi(SETTING_PARAMETER_UPDATE, this.props.userDetail.permissions)) {
            await this.setState({ showConfirmAlert: false })

            if (this.state.targetResolutionTime === 0
                && this.state.targetResponseTime === 0
                && this.state.ticketWaitingTime === 0
                && this.state.toleranceTime === 0
                && this.state.forgeLogoutTime === 0
                && this.state.maxReassignPhoneEmailTime === 0
                && this.state.maxReassignLiveChatTime === 0
                && this.state.maxQueueReassignTime === 0
                && this.state.workstartTime === ''
                && this.state.workendTime === ''
                && this.state.breaktimeTime === 0
                && this.state.cutOffCommissionTime === 0
                && this.state.maxUserOfflineDay === 0
                && this.state.intervalGrabTicketTime === 0
                && this.state.intervalGrabTicketTimeoutTime === 0) {
                this.setState({ showErrorAlert: true })
                return setTimeout(() => this.setState({ showErrorAlert: false }), 1500);
            }

            // Validation Breaktime
            if (this.state.breaktimeTime !== 0 && (this.state.breaktimeTime < 1 || this.state.breaktimeTime > 1440)) {
                this.setState({ errorMessage: "Durasi CS Istirahat minimal 1 menit & maksimal 1440 menit" })
                this.setState({ showErrorAlertResponse: true })
                setTimeout(() => this.setState({ showErrorAlertResponse: false }), 1500);
                return;
            }

            // Validation Cutoff Komisi
            if (this.state.cutOffCommissionTime !== 0 && (this.state.cutOffCommissionTime < 1 || this.state.cutOffCommissionTime > 28)) {
                this.setState({ errorMessage: "Cutoff Komisi minimal 1 & maksimal 28" })
                this.setState({ showErrorAlertResponse: true })
                setTimeout(() => this.setState({ showErrorAlertResponse: false }), 1500);
                return;
            }

            const dataParameterPriority = {
                permission: this.state.priorityDetail.permission,
                name: this.state.priorityDetail.name,
                value: this.state.targetResolutionTime,
                description: this.state.priorityDetail.description,
                updated_at: this.state.priorityDetail.updated_at
            }

            if (this.state.targetResolutionTime !== 0) {
                API_SETTINGS.putDataParameter(dataParameterPriority, this.state.priorityDetail.id, this.props.token)
                    .then(res => {
                        this.setState({ showSuccessAlert: true })
                        setTimeout(() => this.setState({ showSuccessAlert: false }), 1500)
                        setTimeout(() => window.location.reload(), 1500)
                    }).catch(err => {
                        this.setState({ errorMessage: getErrorMessage(err) })
                        this.setState({ showErrorAlertResponse: true })
                        setTimeout(() => this.setState({ showErrorAlertResponse: false }), 1500)
                    })
            }

            const dataParameterChannel = {
                permission: this.state.channelDetail.permission,
                name: this.state.channelDetail.name,
                value: this.state.targetResponseTime,
                description: this.state.channelDetail.description,
                updated_at: this.state.channelDetail.updated_at
            }

            if (this.state.targetResponseTime !== 0) {
                API_SETTINGS.putDataParameter(dataParameterChannel, this.state.channelDetail.id, this.props.token)
                    .then(res => {
                        this.setState({ showSuccessAlert: true })
                        setTimeout(() => this.setState({ showSuccessAlert: false }), 1500)
                        setTimeout(() => window.location.reload(), 1500)
                    }).catch(err => {
                        this.setState({ errorMessage: getErrorMessage(err) })
                        this.setState({ showErrorAlertResponse: true })
                        setTimeout(() => this.setState({ showErrorAlertResponse: false }), 1500)
                    })
            }

            const dataParameterTicketWaiting = {
                permission: this.state.ticketWaitingDetail.permission,
                name: this.state.ticketWaitingDetail.name,
                value: this.state.ticketWaitingTime,
                description: this.state.ticketWaitingDetail.description,
                updated_at: this.state.ticketWaitingDetail.updated_at
            }

            if (this.state.ticketWaitingTime !== 0) {
                API_SETTINGS.putDataParameter(dataParameterTicketWaiting, this.state.ticketWaitingDetail.id, this.props.token)
                    .then(res => {
                        this.setState({ showSuccessAlert: true })
                        setTimeout(() => this.setState({ showSuccessAlert: false }), 1500)
                        setTimeout(() => window.location.reload(), 1500)
                    }).catch(async err => {
                        await this.setState({ errorMessage: getErrorMessage(err) })
                        this.setState({ showErrorAlertResponse: true })
                        setTimeout(() => this.setState({ showErrorAlertResponse: false }), 1500)
                    })
            }

            const dataParameterTolerance = {
                permission: this.state.toleranceDetail.permission,
                name: this.state.toleranceDetail.name,
                value: this.state.toleranceTime,
                description: this.state.toleranceDetail.description,
                updated_at: this.state.toleranceDetail.updated_at
            }

            if (this.state.toleranceTime !== 0) {
                API_SETTINGS.putDataParameter(dataParameterTolerance, this.state.toleranceDetail.id, this.props.token)
                    .then(res => {
                        this.setState({ showSuccessAlert: true })
                        setTimeout(() => this.setState({ showSuccessAlert: false }), 1500)
                        setTimeout(() => window.location.reload(), 1500)
                    }).catch(async err => {
                        await this.setState({ errorMessage: getErrorMessage(err) })
                        this.setState({ showErrorAlertResponse: true })
                        setTimeout(() => this.setState({ showErrorAlertResponse: false }), 1500)
                    })
            }

            const dataParameterForgeLogout = {
                permission: this.state.forgeLogoutDetail.permission,
                name: this.state.forgeLogoutDetail.name,
                value: this.state.forgeLogoutTime,
                description: this.state.forgeLogoutDetail.description,
                updated_at: this.state.forgeLogoutDetail.updated_at
            }

            if (this.state.forgeLogoutTime !== 0) {
                API_SETTINGS.putDataParameter(dataParameterForgeLogout, this.state.forgeLogoutDetail.id, this.props.token)
                    .then(res => {
                        this.setState({ showSuccessAlert: true })
                        setTimeout(() => this.setState({ showSuccessAlert: false }), 1500)
                        setTimeout(() => window.location.reload(), 1500)
                    }).catch(async err => {
                        await this.setState({ errorMessage: getErrorMessage(err) })
                        this.setState({ showErrorAlertResponse: true })
                        setTimeout(() => this.setState({ showErrorAlertResponse: false }), 1500)
                    })
            }

            const dataParameterMaxReassignPhoneEmail = {
                permission: this.state.maxReassignPhoneEmailDetail.permission,
                name: this.state.maxReassignPhoneEmailDetail.name,
                value: this.state.maxReassignPhoneEmailTime,
                description: this.state.maxReassignPhoneEmailDetail.description,
                updated_at: this.state.maxReassignPhoneEmailDetail.updated_at
            }

            if (this.state.maxReassignPhoneEmailTime !== 0) {
                API_SETTINGS.putDataParameter(dataParameterMaxReassignPhoneEmail, this.state.maxReassignPhoneEmailDetail.id, this.props.token)
                    .then(res => {
                        this.setState({ showSuccessAlert: true })
                        setTimeout(() => this.setState({ showSuccessAlert: false }), 1500)
                        setTimeout(() => window.location.reload(), 1500)
                    }).catch(async err => {
                        await this.setState({ errorMessage: getErrorMessage(err) })
                        this.setState({ showErrorAlertResponse: true })
                        setTimeout(() => this.setState({ showErrorAlertResponse: false }), 1500)
                    })
            }

            const dataParameterMaxReassignLiveChat = {
                permission: this.state.maxReassignLiveChatDetail.permission,
                name: this.state.maxReassignLiveChatDetail.name,
                value: this.state.maxReassignLiveChatTime,
                description: this.state.maxReassignLiveChatDetail.description,
                updated_at: this.state.maxReassignLiveChatDetail.updated_at
            }

            if (this.state.maxReassignLiveChatTime !== 0) {
                API_SETTINGS.putDataParameter(dataParameterMaxReassignLiveChat, this.state.maxReassignLiveChatDetail.id, this.props.token)
                    .then(res => {
                        this.setState({ showSuccessAlert: true })
                        setTimeout(() => this.setState({ showSuccessAlert: false }), 1500)
                        setTimeout(() => window.location.reload(), 1500)
                    }).catch(async err => {
                        await this.setState({ errorMessage: getErrorMessage(err) })
                        this.setState({ showErrorAlertResponse: true })
                        setTimeout(() => this.setState({ showErrorAlertResponse: false }), 1500)
                    })
            }

            const dataParameterMaxQueueReassign = {
                permission: this.state.maxQueueReassignDetail.permission,
                name: this.state.maxQueueReassignDetail.name,
                value: this.state.maxQueueReassignTime,
                description: this.state.maxQueueReassignDetail.description,
                updated_at: this.state.maxQueueReassignDetail.updated_at
            }

            if (this.state.maxQueueReassignTime !== 0) {
                API_SETTINGS.putDataParameter(dataParameterMaxQueueReassign, this.state.maxQueueReassignDetail.id, this.props.token)
                    .then(res => {
                        this.setState({ showSuccessAlert: true })
                        setTimeout(() => this.setState({ showSuccessAlert: false }), 1500)
                        setTimeout(() => window.location.reload(), 1500)
                    }).catch(async err => {
                        await this.setState({ errorMessage: getErrorMessage(err) })
                        this.setState({ showErrorAlertResponse: true })
                        setTimeout(() => this.setState({ showErrorAlertResponse: false }), 1500)
                    })
            }

            const dataParamaterWorkstartDetail = {
                permission: this.state.workstartDetail.permission,
                name: this.state.workstartDetail.name,
                value: this.state.workstartTime,
                description: this.state.workstartDetail.description,
                updated_at: this.state.workstartDetail.updated_at
            }

            if (this.state.workstartTime !== '') {
                API_SETTINGS.putDataParameter(dataParamaterWorkstartDetail, this.state.workstartDetail.id, this.props.token)
                    .then(res => {
                        this.setState({ showSuccessAlert: true })
                        setTimeout(() => this.setState({ showSuccessAlert: false }), 1500)
                        setTimeout(() => window.location.reload(), 1500)
                    }).catch(async err => {
                        await this.setState({ errorMessage: getErrorMessage(err) })
                        this.setState({ showErrorAlertResponse: true })
                        setTimeout(() => this.setState({ showErrorAlertResponse: false }), 1500)
                    })
            }

            const dataParamaterWorkendDetail = {
                permission: this.state.workendDetail.permission,
                name: this.state.workendDetail.name,
                value: this.state.workendTime,
                description: this.state.workendDetail.description,
                updated_at: this.state.workendDetail.updated_at
            }

            if (this.state.workendTime !== '') {
                API_SETTINGS.putDataParameter(dataParamaterWorkendDetail, this.state.workendDetail.id, this.props.token)
                    .then(res => {
                        this.setState({ showSuccessAlert: true })
                        setTimeout(() => this.setState({ showSuccessAlert: false }), 1500)
                        setTimeout(() => window.location.reload(), 1500)
                    }).catch(async err => {
                        await this.setState({ errorMessage: getErrorMessage(err) })
                        this.setState({ showErrorAlertResponse: true })
                        setTimeout(() => this.setState({ showErrorAlertResponse: false }), 1500)
                    })
            }

            const dataParamaterBreaktimeDetail = {
                permission: this.state.breaktimeDetail.permission,
                name: this.state.breaktimeDetail.name,
                value: this.state.breaktimeTime,
                description: this.state.breaktimeDetail.description,
                updated_at: this.state.breaktimeDetail.updated_at
            }

            if (this.state.breaktimeTime !== 0) {
                API_SETTINGS.putDataParameter(dataParamaterBreaktimeDetail, this.state.breaktimeDetail.id, this.props.token)
                    .then(res => {
                        this.setState({ showSuccessAlert: true })
                        setTimeout(() => this.setState({ showSuccessAlert: false }), 1500)
                        setTimeout(() => window.location.reload(), 1500)
                    }).catch(async err => {
                        await this.setState({ errorMessage: getErrorMessage(err) })
                        this.setState({ showErrorAlertResponse: true })
                        setTimeout(() => this.setState({ showErrorAlertResponse: false }), 1500)
                    })
            }

            const dataParamaterCutOffCommission = {
                permission: this.state.cutOffCommissionDetail.permission,
                name: this.state.cutOffCommissionDetail.name,
                value: this.state.cutOffCommissionTime,
                description: this.state.cutOffCommissionDetail.description,
                updated_at: this.state.cutOffCommissionDetail.updated_at
            }

            if (this.state.cutOffCommissionTime !== 0) {
                API_SETTINGS.putDataParameter(dataParamaterCutOffCommission, this.state.cutOffCommissionDetail.id, this.props.token)
                    .then(res => {
                        this.setState({ showSuccessAlert: true })
                        setTimeout(() => this.setState({ showSuccessAlert: false }), 1500)
                        setTimeout(() => window.location.reload(), 1500)
                    }).catch(async err => {
                        await this.setState({ errorMessage: getErrorMessage(err) })
                        this.setState({ showErrorAlertResponse: true })
                        setTimeout(() => this.setState({ showErrorAlertResponse: false }), 1500)
                    })
            }

            const dataParamaterMaxUserOffline = {
                permission: this.state.maxUserOfflineDetail.permission,
                name: this.state.maxUserOfflineDetail.name,
                value: this.state.maxUserOfflineDay,
                description: this.state.maxUserOfflineDetail.description,
                updated_at: this.state.maxUserOfflineDetail.updated_at
            }

            if (this.state.maxUserOfflineDay !== 0) {
                API_SETTINGS.putDataParameter(dataParamaterMaxUserOffline, this.state.maxUserOfflineDetail.id, this.props.token)
                    .then(res => {
                        this.setState({ showSuccessAlert: true })
                        setTimeout(() => this.setState({ showSuccessAlert: false }), 1500)
                        setTimeout(() => window.location.reload(), 1500)
                    }).catch(async err => {
                        await this.setState({ errorMessage: getErrorMessage(err) })
                        this.setState({ showErrorAlertResponse: true })
                        setTimeout(() => this.setState({ showErrorAlertResponse: false }), 1500)
                    })
            }

            const dataParamaterIntervalGrabTicket = {
                permission: this.state.intervalGrabTicketDetail.permission,
                name: this.state.intervalGrabTicketDetail.name,
                value: this.state.intervalGrabTicketTime,
                description: this.state.intervalGrabTicketDetail.description,
                updated_at: this.state.intervalGrabTicketDetail.updated_at
            }

            if (this.state.intervalGrabTicketTime !== 0) {
                API_SETTINGS.putDataParameter(dataParamaterIntervalGrabTicket, this.state.intervalGrabTicketDetail.id, this.props.token)
                    .then(res => {
                        this.setState({ showSuccessAlert: true })
                        setTimeout(() => this.setState({ showSuccessAlert: false }), 1500)
                        setTimeout(() => window.location.reload(), 1500)
                    }).catch(async err => {
                        await this.setState({ errorMessage: getErrorMessage(err) })
                        this.setState({ showErrorAlertResponse: true })
                        setTimeout(() => this.setState({ showErrorAlertResponse: false }), 1500)
                    })
            }

            const dataParamaterIntervalGrabTicketTimeout = {
                permission: this.state.intervalGrabTicketTimeoutDetail.permission,
                name: this.state.intervalGrabTicketTimeoutDetail.name,
                value: this.state.intervalGrabTicketTimeoutTime,
                description: this.state.intervalGrabTicketTimeoutDetail.description,
                updated_at: this.state.intervalGrabTicketTimeoutDetail.updated_at
            }

            if (this.state.intervalGrabTicketTimeoutTime !== 0) {
                API_SETTINGS.putDataParameter(dataParamaterIntervalGrabTicketTimeout, this.state.intervalGrabTicketTimeoutDetail.id, this.props.token)
                    .then(res => {
                        this.setState({ showSuccessAlert: true })
                        setTimeout(() => this.setState({ showSuccessAlert: false }), 1500)
                        setTimeout(() => window.location.reload(), 1500)
                    }).catch(async err => {
                        await this.setState({ errorMessage: getErrorMessage(err) })
                        this.setState({ showErrorAlertResponse: true })
                        setTimeout(() => this.setState({ showErrorAlertResponse: false }), 1500)
                    })
            }
        }
    }

    componentDidMount() {
        this._isMounted = true;

        this.getListParameterPriority();
        this.getListParameterChannel();
        this.getListParameterTicketWaiting();
        this.getListParameterTolerance();
        this.getListParameterForgeLogout();
        this.getListParameterMaxReassignPhoneEmail();
        this.getListParameterMaxReassignLiveChat();
        this.getListParameterMaxQueueReassign();
        this.getListParameterWorkstart();
        this.getListParameterWorkend();
        this.getListParameterBreaktime();
        this.getListParameterCutOffCommission();
        this.getListParameterMaxUserOffline();
        this.getListParameterIntervalGrabTicket();
        this.getListParameterIntervalGrabTicketTimeout();

        document.addEventListener("wheel", function (event) {
            if (document.activeElement.type === "number") {
                document.activeElement.blur();
            }
        });
    }

    componentWillUnmount() {
        this._isMounted = false;

        document.removeEventListener("wheel", function (event) {
            if (document.activeElement.type === "number") {
                document.activeElement.blur();
            }
        });
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[SETTING_PARAMETER_VIEW]} userPermission={this.props.userDetail.permissions}>
                <form onSubmit={this.handleSubmit} className="flex text-gray-600 calculate-layout">
                    <div className="w-full bg-white rounded-lg p-5 relative">
                        <div className="border-b-2 border-gray overflow-y-auto" style={{ height: "90%" }}>
                            <p className="text-darkblue font-bold mb-5">Parameter</p>
                            <div className="flex justify-between">
                                <div className="w-full pr-20">
                                    <div className="mb-5 ml-0.5">
                                        <label>Daftar Skala Prioritas</label>
                                        <Dropdown
                                            id="ddlpriority"
                                            placeholder="Pilih Skala Prioritas"
                                            handleChange={this.handleChangePriority}
                                            data={this.state.priority.data.map(data => ({ value: data.id, label: data.name.substring(32, data.name.length).charAt(0).toUpperCase() + data.name.substring(32, data.name.length).slice(1), updatedAt: data.updated_at, updatedBy: data.modified_by }))}
                                        />
                                    </div>
                                    <div className="mb-5 ml-0.5">
                                        <label>Target Resolusi</label>
                                        <div className="custom-input-container flex justify-between items-center">
                                            <input type="number" id="tsltargetresolutiontime" placeholder="Tulis Target Resolusi" className="custom-input w-full" name="targetResolutionTime" onChange={this.handleChange} defaultValue={this.state.priorityDetail.value} disabled={this.state.targetResolutionTimeDisabled} autoComplete="off" />
                                            Menit
                                        </div>
                                    </div>
                                    <p className={this.state.priority.updatedAt === '' && this.state.priority.updatedBy === '' ? "hidden" : "text-darkred text-xs mb-5"}>Waktu diperbaharui {moment.utc(this.state.priority.updatedAt).format('DD MMM YYYY HH:mm')}{this.state.priority.updatedBy !== '' && ' oleh ' + this.state.priority.updatedBy}</p>
                                    <div className="mb-5 ml-0.5">
                                        <label>Durasi Tiket Mengambang</label>
                                        <div className="custom-input-container flex justify-between items-center">
                                            <input type="number" id="tslticketwaitingtime" placeholder="Tulis Durasi Tiket" className="custom-input w-full" name="ticketWaitingTime" onChange={this.handleChange} defaultValue={this.state.ticketWaitingDetail.value} autoComplete="off" />
                                            Menit
                                        </div>
                                    </div>
                                    <p className="text-darkred text-xs mb-5">Waktu diperbaharui {moment.utc(this.state.ticketWaiting.updatedAt).format('DD MMM YYYY HH:mm')}{this.state.ticketWaiting.updatedBy !== '' && ' oleh ' + this.state.ticketWaiting.updatedBy}</p>
                                    <div className="mb-5 ml-0.5">
                                        <label>Toleransi Assign CS</label>
                                        <div className="custom-input-container flex justify-between items-center">
                                            <input type="number" id="tsltolerancetime" placeholder="Tulis Durasi Tiket" className="custom-input w-full" name="toleranceTime" onChange={this.handleChange} defaultValue={this.state.toleranceDetail.value} autoComplete="off" />
                                            Menit
                                        </div>
                                    </div>
                                    <p className="text-darkred text-xs mb-5">Waktu diperbaharui {moment.utc(this.state.tolerance.updatedAt).format('DD MMM YYYY HH:mm')}{this.state.tolerance.updatedBy !== '' && ' oleh ' + this.state.tolerance.updatedBy}</p>
                                    <div className="mb-5 ml-0.5">
                                        <label>Force Logout</label>
                                        <div className="custom-input-container flex justify-between items-center">
                                            <input type="number" id="tslforcelogouttime" placeholder="Tulis Durasi Tiket" className="custom-input w-full" name="forgeLogoutTime" onChange={this.handleChange} defaultValue={this.state.forgeLogoutDetail.value} autoComplete="off" />
                                            Menit
                                        </div>
                                    </div>
                                    <p className="text-darkred text-xs mb-5">Waktu diperbaharui {moment.utc(this.state.forgeLogout.updatedAt).format('DD MMM YYYY HH:mm')}{this.state.forgeLogout.updatedBy !== '' && ' oleh ' + this.state.forgeLogout.updatedBy}</p>
                                    <div className="mb-5 ml-0.5">
                                        <label>Jam CS Mulai Beroperasi </label>
                                        <span className="text-darkred">*</span>
                                        <input type="time" id="tslshiftstart" placeholder="hh:mm" className="form-control" name="workstartTime" onChange={this.handleChange} defaultValue={this.state.workstartDetail.value} autoComplete="off" />
                                    </div>
                                    <p className="text-darkred text-xs mb-5">Waktu diperbaharui {moment.utc(this.state.workstart.updatedAt).format('DD MMM YYYY HH:mm')}{this.state.workstart.updatedBy !== '' && ' oleh ' + this.state.workstart.updatedBy}</p>
                                    <div className="mb-5 ml-0.5">
                                        <label>Durasi CS Istirahat </label>
                                        <span className="text-darkred">*</span>
                                        <div className="custom-input-container flex justify-between items-center">
                                            <input type="number" id="tslshiftbreak" placeholder="Tulis Durasi Istirahat" className="custom-input w-full" name="breaktimeTime" onChange={this.handleChange} defaultValue={this.state.breaktimeDetail.value} autoComplete="off" />
                                            Menit
                                        </div>
                                    </div>
                                    <p className="text-darkred text-xs mb-5">Waktu diperbaharui {moment.utc(this.state.breaktime.updatedAt).format('DD MMM YYYY HH:mm')}{this.state.breaktime.updatedBy !== '' && ' oleh ' + this.state.breaktime.updatedBy}</p>
                                    <div className="mb-5 ml-0.5">
                                        <label>Batas Maksimal Offline </label>
                                        <span className="text-darkred">*</span>
                                        <div className="custom-input-container flex justify-between items-center">
                                            <input type="number" id="tslmaxuseroffline" placeholder="Tulis Batas Maksimal Offline" className="custom-input w-full" name="maxUserOfflineDay" onChange={this.handleChange} defaultValue={this.state.maxUserOfflineDetail.value} autoComplete="off" />
                                            Hari
                                        </div>
                                    </div>
                                    <p className="text-darkred text-xs mb-5">Waktu diperbaharui {moment.utc(this.state.maxUserOffline.updatedAt).format('DD MMM YYYY HH:mm')}{this.state.maxUserOffline.updatedBy !== '' && ' oleh ' + this.state.maxUserOffline.updatedBy}</p>
                                    <div className="mb-5 ml-0.5">
                                        <label>Interval Pengaktifan Tombol Ambil Tiket </label>
                                        <span className="text-darkred">*</span>
                                        <div className="custom-input-container flex justify-between items-center">
                                            <input type="number" id="tslintervalgrabtickettimeout" placeholder="Tulis Interval Pengambilan Tiket" className="custom-input w-full" name="intervalGrabTicketTimeoutTime" onChange={this.handleChange} defaultValue={this.state.intervalGrabTicketTimeoutDetail.value} autoComplete="off" />
                                            Detik
                                        </div>
                                    </div>
                                    <p className="text-darkred text-xs mb-5">Waktu diperbaharui {moment.utc(this.state.intervalGrabTicketTimeout.updatedAt).format('DD MMM YYYY HH:mm')}{this.state.intervalGrabTicketTimeout.updatedBy !== '' && ' oleh ' + this.state.intervalGrabTicketTimeout.updatedBy}</p>
                                </div>
                                <div className="w-full pr-20">
                                    <div className="mb-5 ml-0.5">
                                        <label>Daftar Tiket Channel</label>
                                        <Dropdown
                                            id="ddlchannel"
                                            placeholder="Pilih Tiket Channel"
                                            handleChange={this.handleChangeChannel}
                                            data={this.state.channel.data.map(data => ({ value: data.id, label: data.name.substring(18, data.name.length).charAt(0).toUpperCase() + data.name.substring(18, data.name.length).slice(1), updatedAt: data.updated_at, updatedBy: data.modified_by }))}
                                        />
                                    </div>
                                    <div className="mb-5 ml-0.5">
                                        <label>Target Response</label>
                                        <div className="custom-input-container flex justify-between items-center">
                                            <input type="number" id="tsltargetresponsetime" placeholder="Tulis Target Response" className="custom-input w-full" name="targetResponseTime" onChange={this.handleChange} defaultValue={this.state.channelDetail.value} disabled={this.state.targetResponseTimeDisabled} autoComplete="off" />
                                            Menit
                                        </div>
                                    </div>
                                    <p className={this.state.channel.updatedAt === '' && this.state.channel.updatedBy === '' ? "hidden" : "text-darkred text-xs mb-5"}>Waktu diperbaharui {moment.utc(this.state.channel.updatedAt).format('DD MMM YYYY HH:mm')}{this.state.channel.updatedBy !== '' && ' oleh ' + this.state.channel.updatedBy}</p>
                                    <div className="mb-5 ml-0.5">
                                        <label>Max Reassign Phone & Email</label>
                                        <input type="number" id="tslmaxreassignphoneemailtime" placeholder="Tulis Jumlah Maksimal" className="form-control" name="maxReassignPhoneEmailTime" onChange={this.handleChange} defaultValue={this.state.maxReassignPhoneEmailDetail.value} autoComplete="off" />
                                    </div>
                                    <p className="text-darkred text-xs mb-5">Waktu diperbaharui {moment.utc(this.state.maxReassignPhoneEmail.updatedAt).format('DD MMM YYYY HH:mm')}{this.state.maxReassignPhoneEmail.updatedBy !== '' && ' oleh ' + this.state.maxReassignPhoneEmail.updatedBy}</p>
                                    <div className="mb-5 ml-0.5">
                                        <label>Max Reassign Live Chat</label>
                                        <input type="number" id="tslmacreassignlivechattime" placeholder="Tulis Jumlah Maksimal" className="form-control" name="maxReassignLiveChatTime" onChange={this.handleChange} defaultValue={this.state.maxReassignLiveChatDetail.value} autoComplete="off" />
                                    </div>
                                    <p className="text-darkred text-xs mb-5">Waktu diperbaharui {moment.utc(this.state.maxReassignLiveChat.updatedAt).format('DD MMM YYYY HH:mm')}{this.state.maxReassignLiveChat.updatedBy !== '' && ' oleh ' + this.state.maxReassignLiveChat.updatedBy}</p>
                                    <div className="mb-5 ml-0.5">
                                        <label>Max Queue Reassign</label>
                                        <input type="number" id="tslmaxqueuereassigntime" placeholder="Tulis Jumlah Maksimal" className="form-control" name="maxQueueReassignTime" onChange={this.handleChange} defaultValue={this.state.maxQueueReassignDetail.value} autoComplete="off" />
                                    </div>
                                    <p className="text-darkred text-xs mb-5">Waktu diperbaharui {moment.utc(this.state.maxQueueReassign.updatedAt).format('DD MMM YYYY HH:mm')}{this.state.maxQueueReassign.updatedBy !== '' && ' oleh ' + this.state.maxQueueReassign.updatedBy}</p>
                                    <div className="mb-5 ml-0.5">
                                        <label>Jam CS Selesai Beroperasi </label>
                                        <span className="text-darkred">*</span>
                                        <input type="time" id="tslshiftend" placeholder="hh:mm" className="form-control" name="workendTime" onChange={this.handleChange} defaultValue={this.state.workendDetail.value} autoComplete="off" />
                                    </div>
                                    <p className="text-darkred text-xs mb-5">Waktu diperbaharui {moment.utc(this.state.workend.updatedAt).format('DD MMM YYYY HH:mm')}{this.state.workend.updatedBy !== '' && ' oleh ' + this.state.workend.updatedBy}</p>
                                    <div className="mb-5 ml-0.5">
                                        <label>Cutoff Komisi </label>
                                        <span className="text-darkred">*</span>
                                        <div className="custom-input-container flex justify-between items-center">
                                            Tanggal
                                            <input type="number" id="tslcutoffkomisi" placeholder="Tulis Tanggal" className="custom-input w-full ml-2" name="cutOffCommissionTime" onChange={this.handleChange} defaultValue={this.state.cutOffCommissionDetail.value} />
                                        </div>
                                    </div>
                                    <p className="text-darkred text-xs mb-5">Waktu diperbaharui {moment.utc(this.state.cutOffCommission.updatedAt).format('DD MMM YYYY HH:mm')}{this.state.cutOffCommission.updatedBy !== '' && ' oleh ' + this.state.cutOffCommission.updatedBy}</p>
                                    <div className="mb-5 ml-0.5">
                                        <label>Interval Pengambilan Tiket </label>
                                        <span className="text-darkred">*</span>
                                        <div className="custom-input-container flex justify-between items-center">
                                            <input type="number" id="tslintervalgrabticket" placeholder="Tulis Interval Pengambilan Tiket" className="custom-input w-full" name="intervalGrabTicketTime" onChange={this.handleChange} defaultValue={this.state.intervalGrabTicketDetail.value} autoComplete="off" />
                                            Menit
                                        </div>
                                    </div>
                                    <p className="text-darkred text-xs mb-5">Waktu diperbaharui {moment.utc(this.state.intervalGrabTicket.updatedAt).format('DD MMM YYYY HH:mm')}{this.state.intervalGrabTicket.updatedBy !== '' && ' oleh ' + this.state.intervalGrabTicket.updatedBy}</p>
                                </div>
                            </div>
                        </div>
                        <CheckPermissionComponent permissionConstant={[SETTING_PARAMETER_UPDATE]} userPermission={this.props.userDetail.permissions}>
                            <div className="absolute bottom-5 right-5">
                                <button type="button" id="btncancel" className="bg-white rounded text-darkblue border border-darkblue focus:outline-none px-10 py-2 mt-3 mr-2" onClick={() => window.location.reload()}>Batal</button>
                                <button type="submit" id="btnsave" className="bg-lightblue rounded text-white border border-lightblue focus:outline-none px-10 py-2 mt-3 ml-2">Simpan</button>
                            </div>
                        </CheckPermissionComponent>
                    </div>
                    <Alert show={this.state.showConfirmAlert} icon="warning" button={true} title="Apakah Anda yakin mengubah parameter?" close={() => this.setState({ showConfirmAlert: false })} submit={() => this.handleUpdateParameter()} />
                    <Alert show={this.state.showSuccessAlert} icon="success" title="Data berhasil disimpan!" />
                    <Alert show={this.state.showErrorAlert} icon="warning" title="Tidak ada perubahan data!" />
                    <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} />
                </form>
            </CheckPermissionComponent >
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Parameter);